import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { sendPostReq } from '../DAL/http';

function Login() {
  const [username,setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,     setError] = useState("");
  const [loaded, setLoaded] = useState(0);
  const navigate = useNavigate();


  useEffect(() => {
    setTimeout(() => {
      setLoaded(1);
    }, 2000);
  }, []);
  useEffect(() => {},[]);

  const fieldValidate=(username,password)=>{
    if (username === "" || password === "") {
      setError("Please enter both Username and password.");
      return false;
    }
    setError("");
    return true;
  }

  


  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await sendPostReq("users/validatelogin",{
      username,password
    });
  
    // console.log(data)
    setUsername("");
    setPassword("");
    // console.log("API Response: ", response);

    if (response.statusCode === "200") {
    
      // console.log(response.data)
      
      sessionStorage.setItem("loggedin", "true");
      console.log(sessionStorage.getItem("loggedin"));
      navigate("/home");
      

    } else {
      setError(response.message);
    }
  };
  return (
    <div
  className="page-wrapper"
  id="main-wrapper"
  data-layout="vertical"
  data-navbarbg="skin6"
  data-sidebartype="full"
  data-sidebar-position="fixed"
  data-header-position="fixed"
>

  <div className="position-relative overflow-hidden radial-gradient min-vh-100 d-flex align-items-center justify-content-center">
    <div className="d-flex align-items-center justify-content-center w-100">
      <div className="row justify-content-center w-100">
      <h2 className="text-center" style={{fontSize:"30px", color:"#0F172A",marginBottom:"20px"}}> Login Form </h2>
        <div className="col-md-8 col-lg-6 col-xxl-3">
          <div className="card mb-0">
            <div className="card-body">
              {/* <a
                href="./index.html"
                className="text-nowrap logo-img text-center d-block py-3 w-100"
              >
                <img
                  src="../../assets/images/logos/dark-logo.svg"
                  width={180}
                  alt=""
                />
              </a> */}
            
              <form  onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Username
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"  onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="exampleInputPassword1" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1" onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {/* {error && <div className="text-danger">{error}</div>} */}
                <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      Login
                    </button>
               </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default Login;
